import {useState} from "react";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import IconButton from '@mui/material/IconButton';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import GetGuideAtomoxetine from './GetGuideAtomoxetine'

export default function Dia_atomoxetine() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
    <IconButton onClick={handleOpen} size="small" >
            <FeaturedPlayListIcon sx={{fontSize: '110%', color: 'traffic.green', '&:hover': { color: 'primary.light'}, }}/>
    </IconButton>

    <CustomDialog open={open} onClose={handleClose}

        title="Atomoxetine - Clinical Guidelines"
        content={ <GetGuideAtomoxetine />}

    />

</>
)}